import { render, staticRenderFns } from "./DashboardPyG.vue?vue&type=template&id=d83acc1e&scoped=true&"
import script from "./DashboardPyG.vue?vue&type=script&lang=js&"
export * from "./DashboardPyG.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPyG.vue?vue&type=style&index=0&id=d83acc1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83acc1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VContainer,VIcon})
